/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Grow_TitleInputs */

const en_how_page_grow_title = /** @type {(inputs: How_Page_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach sees every set.`)
};

const pl_how_page_grow_title = /** @type {(inputs: How_Page_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener widzi każdą serię.`)
};

/**
* | output |
* | --- |
* | "Your coach sees every set." |
*
* @param {How_Page_Grow_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_grow_title = /** @type {((inputs?: How_Page_Grow_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Grow_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_grow_title(inputs)
	return en_how_page_grow_title(inputs)
});